var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-header"},[_c('div',{staticClass:"menu"},[_vm._l((_vm.items),function(menuitem,index){return [_c('div',{key:index,class:'left-menu menuitem' + (index == _vm.activeIndex ? ' active' : '')},[_c('img',{attrs:{"src":menuitem.image},on:{"click":function($event){return _vm.handleSelect(index)}}})])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-308d9496","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/sHeader.vue
// module id = null
// module chunks = 